import React from 'react';
import { DestinationButton, SelectDestination } from './styles';
import SelectPortoSeguro from 'assets/images/selectDestinationPortoSeguro.svg';
import SelectArraial from 'assets/images/selectDestinationArraial.svg';
import SelectCaraiva from 'assets/images/selectDestinationCaraiva.svg';
import SelectTrancoso from 'assets/images/selectDestinationTrancoso.svg';
import SelectValeVerde from 'assets/images/selectDestinationValeVerde.svg';
import SelectlitoralNorte from 'assets/images/SelectDestinationLitoralNorte.svg';
import SelectcentroHistorico from 'assets/images/SelectDestinationCentroHistorico.svg';

interface Props {
  selected: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
}

enum DestinationTitleEnum {
  portoSeguro = 'Porto Seguro',
  arraial = "Arraial D'Ajuda",
  caraiva = 'Caraíva',
  centroHistorico = 'Centro Histórico',
  litoralNorte = 'Litoral Norte',
  trancoso = 'Trancoso',
  valeVerde = 'Vale Verde',
}

enum DestinationSlugEnum {
  portoSeguro = 'porto-seguro',
  arraial = 'arraial-dajuda',
  caraiva = 'caraiva',
  centroHistorico = 'centro-historico',
  litoralNorte = 'litoral-norte',
  trancoso = 'trancoso',
  valeVerde = 'vale-verde',
}

const destinations = [
  {
    title: DestinationTitleEnum.portoSeguro,
    SelectImg: SelectPortoSeguro,
    slug: DestinationSlugEnum.portoSeguro,
  },
  {
    title: DestinationTitleEnum.arraial,
    SelectImg: SelectArraial,
    slug: DestinationSlugEnum.arraial,
  },
  {
    title: DestinationTitleEnum.caraiva,
    SelectImg: SelectCaraiva,
    slug: DestinationSlugEnum.caraiva,
  },
  {
    title: DestinationTitleEnum.centroHistorico,
    SelectImg: SelectcentroHistorico,
    slug: DestinationSlugEnum.centroHistorico,
  },
  {
    title: DestinationTitleEnum.litoralNorte,
    SelectImg: SelectlitoralNorte,
    slug: DestinationSlugEnum.litoralNorte,
  },
  {
    title: DestinationTitleEnum.trancoso,
    SelectImg: SelectTrancoso,
    slug: DestinationSlugEnum.trancoso,
  },
  {
    title: DestinationTitleEnum.valeVerde,
    SelectImg: SelectValeVerde,
    slug: DestinationSlugEnum.valeVerde,
  },
];

const DestinationsPage = (props: Props): JSX.Element => {
  const { selected, setSelected } = props;

  return (
    <SelectDestination>
      {destinations.map(destination => {
        return (
          <DestinationButton
            key={destination.slug}
            className={selected === destination.slug ? 'selected' : 'disabled'}
            onClick={() => setSelected(destination.slug)}>
            <img src={destination.SelectImg} alt={destination.title} />
          </DestinationButton>
        );
      })}
    </SelectDestination>
  );
};

export default DestinationsPage;
